import { CPFValidator } from './cpf-validator'
import { CPFValidatorAdapter } from './cpf-validator-adapter'

export const cpfValidator = new CPFValidator(new CPFValidatorAdapter())
